import * as React from 'react';

import Drawer from '@mui/material/Drawer'

interface DetailDrawerProps {
    children:React.ReactElement,
    setOpenDetailDrawer:(open:boolean)=>void,
    openDetailDrawer:boolean
    
}
export default function DetailDrawer(props:DetailDrawerProps) {


  const toggleDrawer =
    (open: boolean) =>
    (event: React.KeyboardEvent | React.MouseEvent) => {
      if (
        event &&
        event.type === 'keydown' &&
        ((event as React.KeyboardEvent).key === 'Tab' ||
          (event as React.KeyboardEvent).key === 'Shift')
      ) {
        return;
      }

      props.setOpenDetailDrawer(open)
    };


  return (
    <div>
            <Drawer
               id="Detail_Drawer"
                anchor={'bottom'}
                open={props.openDetailDrawer}
                onClose={toggleDrawer(false)}
                sx={{
                  '& .MuiPaper-root':{
                    padding:'17px'
                  }
                }}
                >
                {
                    props.children
                }
        </Drawer>
    </div>
  );
}
